module.exports = __webpack_public_path__ + "img/food-delivery.cf940c7f.svg";